import { IAction, StateStatus } from 'redux/utils/common';
import * as Types from './type';
import { ISavedSearchesData } from 'services/api/client';

export interface IState {
  savedSearchesData: {
    status: StateStatus | null;
    data: ISavedSearchesData | null;
  };
  deleteSavedSearches: {
    status: StateStatus | null;
  };
  addSavedSearches: {
    status: StateStatus | null;
  };
}

const initialState: IState = {
  savedSearchesData: {
    status: null,
    data: null,
  },
  deleteSavedSearches: {
    status: null,
  },
  addSavedSearches: {
    status: null,
  },
};

const SingleClientSavedSearchesReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.GET_CLIENT_SAVED_SEARCH:
      return {
        ...state,
        savedSearchesData: {
          ...state.savedSearchesData,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.DELETE_SAVED_SEARCH:
      return {
        ...state,
        deleteSavedSearches: {
          ...state.deleteSavedSearches,
          status: action.status ?? null,
        },
      };
    case Types.ADD_SAVED_SEARCH:
      return {
        ...state,
        addSavedSearches: {
          ...state.addSavedSearches,
          status: action.status ?? null,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default SingleClientSavedSearchesReducer;
